// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3oYDy","left":"InfoRow_left__3Pp7u"};